import {
  faCircleCheck,
  faCircleXmark,
  faMagnifyingGlass,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MaterialReactTable } from "material-react-table";
import { useMemo, useState } from "react";
import { Button, Card, Col, FloatingLabel, Form, Row } from "react-bootstrap";

const StaffDetail = ({ hotels, staff }) => {
  const [filters, setFilters] = useState({
    connectAccount: "",
    serviceName: "",
  });
  const [filteredStaff, setFilteredStaff] = useState(staff);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const handleInputChange = (fieldName, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [fieldName]: value,
    }));
  };

  const applyFilters = () => {
    const filtered = staff.filter(filterStaff);
    setFilteredStaff(filtered);
  };

  const filterStaff = (member) => {
    const { connectAccount, serviceName } = filters;
    return (
      (!connectAccount ||
        member.stripe_id
          .toLowerCase()
          .includes(connectAccount.toLowerCase())) &&
      (!serviceName ||
        member.serviceName.toLowerCase().includes(serviceName.toLowerCase()))
    );
  };

  const clearFilter = () => {
    setFilters({
      connectAccount: "",
      serviceName: "",
    });
    setFilteredStaff(staff);
  };

  // Prepare data for MRT
  const data = useMemo(() => {
    return filteredStaff.map((member, index) => {
      const hotel = hotels.find((hotel) => hotel._id === member.hotel);
      return {
        id: member._id,
        index: index + 1,
        dateAdded: new Date(member.createdAt).toLocaleDateString("en-US"),
        name: `${member.firstName} ${member.lastName}`,
        serviceName: member.serviceName,
        type: member.type,
        clientName: hotel ? hotel.companyName : "Unknown",
        connectAccount: member.stripe_id,
        status: member.chargesStatus ? "Active" : "Inactive",
        statusIcon: member.chargesStatus ? (
          <FontAwesomeIcon icon={faCircleCheck} className="text-success" />
        ) : (
          <FontAwesomeIcon icon={faCircleXmark} className="text-danger" />
        ),
      };
    });
  }, [filteredStaff, hotels]);

  // Define columns for MRT
  const columns = useMemo(
    () => [
      {
        accessorKey: "index",
        header: "#",
        size: 50,
      },
      {
        accessorKey: "dateAdded",
        header: "Date Added",
        size: 100,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 150,
        Cell: ({ cell }) => (
          <span className="fw-bold text-primary">{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "serviceName",
        header: "@",
        size: 80,
        Cell: ({ cell }) => (
          <span className="text-success">{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "type",
        header: "Type",
        size: 80,
        Cell: ({ cell }) => (
          <span className="text-muted">{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "clientName",
        header: "Client Name",
        size: 200,
        Cell: ({ cell }) => (
          <span className="fw-bold text-primary">{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "connectAccount",
        header: "Connect Account",
        size: 200,
        Cell: ({ cell }) => (
          <span className="text-muted fst-italic">{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "statusIcon",
        header: "Status",
        size: 80,
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    []
  );

  return (
    <>
      <Row className="align-items-center justify-content-end">
        <Col xs={12} md={3} className="mb-2 mb-md-0">
          <FloatingLabel label="Connect account">
            <Form.Control
              type="text"
              placeholder="Connect account"
              value={filters.connectAccount}
              onChange={(e) =>
                handleInputChange("connectAccount", e.target.value)
              }
            />
          </FloatingLabel>
        </Col>
        <Col xs={12} md={3} className="mb-2 mb-md-0">
          <FloatingLabel label="Service Name">
            <Form.Control
              type="text"
              placeholder="Service Name"
              value={filters.serviceName}
              onChange={(e) => handleInputChange("serviceName", e.target.value)}
            />
          </FloatingLabel>
        </Col>
        <Col xs={12} md="auto" className="d-flex justify-content-end">
          <Button variant="secondary" className="me-2" onClick={clearFilter}>
            <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
          <Button
            className="py-2 px-3"
            variant="success"
            onClick={applyFilters}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className="me-1" />
            Apply Filter
          </Button>
        </Col>
      </Row>
      <Row className="my-3 px-3">
        <MaterialReactTable
          columns={columns}
          data={data}
          enablePagination={true}
          manualPagination={false}
          rowCount={data.length}
          onPaginationChange={setPagination}
          state={{ pagination }}
          enableTopToolbar={false}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0.5rem",
              border: "1px solid #e0e0e0",
            },
          }}
          muiTableHeadRowProps={{
            sx: {
              backgroundColor: "#f5f5f5",
              color: "#333",
            },
          }}
          muiTableContainerProps={{
            sx: {
              // maxHeight: "calc(100vh - 300px)",
            },
          }}
          muiToolbarAlertBannerProps={{
            sx: {
              borderRadius: "0.5rem",
            },
          }}
          muiBottomToolbarProps={{
            sx: {
              borderRadius: "0 0 0.5rem 0.5rem",
            },
          }}
          muiTopToolbarProps={{
            sx: {
              borderRadius: "0.5rem 0.5rem 0 0",
            },
          }}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "Actions",
              size: 100,
            },
          }}
          initialState={{
            density: "compact",
          }}
        />
      </Row>
    </>
  );
};

export default StaffDetail;
